import { render, staticRenderFns } from "./CalendarEventsDropdown.vue?vue&type=template&id=944131c2&"
import script from "./CalendarEventsDropdown.vue?vue&type=script&lang=js&"
export * from "./CalendarEventsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports